import styled from 'styled-components';
import { Body2Styles } from '../typography';
import { getColor } from '../../../src/styled/utils';
export const StyledLink = styled.a `
  ${Body2Styles};
  color: ${getColor('primary')};
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  cursor: pointer;

  /* for react-router active state */
  &.active {
    color: ${getColor('linkCurrent')};
  }

  &:not(.active):visited {
    color: ${getColor('linkVisited')};
  }
  /* stylelint-disable-next-line no-descending-specificity */
  &:hover {
    color: ${getColor('linkHover')} !important;
  }
`;
